import React from "react";
import CloseIcon from "@src/assets/svg/close-icon.svg";
import { Title } from "@components/atoms/title/title";

import { HintTitle } from "@components/atoms/hint-title/hint-title";
import { Button } from "@components/atoms/buttons/button/button";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { GlassyModal } from "../glassy-modal/glassy-modal";
import { GlassyModalHeader } from "@src/components/molecules/glassy-modal-header/glassy-modal-header";
import { HorizontalSeparator } from "@src/components/atoms/horizontal-separator/horizontal-separator";
import { Spacer16 } from "@src/components/atoms/spacer-16/spacer-16";
import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";

import styles from "./unsaved-condition-monitoring-for-node-manager-navigation-modal.module.scss";
import { useUnsavedConditionMonitoringForNodeManagerNavigationModalHook } from "./use-unsaved-condition-monitoring-for-node-manager-navigation-modal-hook";
import { useI18N } from "@src/language/language-context";

const cssClassName =
  "unsaved-condition-monitoring-for-node-manager-navigation-modal";

export const UnsavedConditionMonitoringForNodeManagerNavigationModal = () => {
  const {
    closeModal,
    saveStructureAndProceed,
    proceedWithoutSaving,
    saveStructureLoading,
  } = useUnsavedConditionMonitoringForNodeManagerNavigationModalHook();
  const i18n = useI18N();

  const texts = {
    subTitle: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.subTitle",
    ),
    title: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.title",
    ),
    descriptionFirstLine: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.descriptionFirstLine",
    ),
    descriptionSecondLine: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.descriptionSecondLine",
    ),
    proceedWithoutSavingButton: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.proceedWithoutSavingButton",
    ),
    saveConditionMonitoringButtonText: i18n(
      "modules.unsavedConditionMonitoringForNodeManagerNavigationModal.saveConditionMonitoringButtonText",
    ),
  };

  return (
    <GlassyModal>
      <div className={styles[cssClassName]}>
        <GlassyModalHeader
          title={texts.subTitle}
          rightIcon={CloseIcon}
          rightIconFunction={closeModal}
        />
        <HorizontalSeparator verticalMargin={16} />
        <Spacer16 />
        <div className={styles[`${cssClassName}__modal-content`]}>
          <Title text={texts.title} />
          <div className={styles[`${cssClassName}__hint-content`]}>
            <HintTitle text={texts.descriptionFirstLine} />
            <HintTitle text={texts.descriptionSecondLine} />
          </div>
          <FlexRowContainer justifyContent="center">
            <ButtonWithLoader
              fun={saveStructureAndProceed}
              text={texts.saveConditionMonitoringButtonText}
              loading={saveStructureLoading}
            />
            <Button
              variant={["secondary", "alert"]}
              fun={proceedWithoutSaving}
              text={texts.proceedWithoutSavingButton}
            />
          </FlexRowContainer>
        </div>
      </div>
    </GlassyModal>
  );
};
